import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { Controller, useForm } from "react-hook-form";
import { DatePicker } from "rsuite";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { errorTypes } from "../../../utility/InputValidation";
import PlusIcon from "../../../components/Icons/PlusIcon";
import calculateFinancialYears, { formatAmount, parseAmount, getCurrentFinancialYear } from "../../../utility/CommonFunctions";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { Spinner } from "reactstrap";
import moment from "moment";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import SearchSelectInput from "../../../components/comman/SearchSelectInput";

export default function CreateReimbursementForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [files, setFiles] = useState([]);
  const [reimbursementData, setReimbursementData] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const toggleConfirmModal = () => setConfirmModal(!confirmModal);
  const [selectedId, setSelectedId] = useState("");
  const [financialYears, setFinancialYears] = useState([]);
  const [activeFinancialYear, setActiveFinancialYear] = useState("");
  const [expenseList, setExpenseList] = useState([]);
  const [selectedExpenseHeadId, setSelectedExpenseHeadId] = useState("");
  const [expenseHeadItems, setExpenseHeadItems] = useState([]);
  const [state, setState] = useState({
    OandMSites: [],
    projectSites: [],
    assignedSites: [],
    siteId: "",
    siteName: "",
    isLoadingSite: false,
  });
  const userDetails = useSelector((state) => state.root.userDetails);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    control,
    formState: { errors },
    getValues,
  } = useForm({
    defaultValues: {
      reimbursementFormItem: [
        { item: "", quantity: "", rate: "", gst: "", total: "" },
      ],
    },
  });

  useEffect(() => {
    if (
      userDetails?.type === 2 &&
      (state?.OandMSites.length === 0 || state?.assignedSites.length === 0)
    ) {
      GetAllSitesList();
    } else if (
      state?.OandMSites.length === 0 ||
      state?.assignedSites.length === 0
    ) {
      getAssignedSites();
    }
    if (location?.state) {
      getReimbursementFormDetails();
    }
  }, []);

  const fetchBudget = (siteId, fy) => {
    if (!siteId) return;
    const financialYear = fy || activeFinancialYear || getCurrentFinancialYear();
    const API = `${apiUrl.get_site_budget}siteId=${siteId}&financialYear=${financialYear}`;
    callApi(API, { method: "GET" }).then((response) => {
      if (response?.status) {
        const list = response.data || [];
        setExpenseList(list);

        // If editing/updating, restore the selected expense head items
        if (location?.state?.reimbursementForm?.expenseHeadId) {
          const selectedBudget = list.find(b => b.expensehead?.id === location.state.reimbursementForm.expenseHeadId);
          setExpenseHeadItems(selectedBudget?.sitebudgetitems || []);
          setSelectedExpenseHeadId(location.state.reimbursementForm.expenseHeadId);
          setValue("expenseHeadId", location.state.reimbursementForm.expenseHeadId);
        }
      }
    });
  };

  const handleFinancialYearChange = (e) => {
    const fy = e.target.value;
    setActiveFinancialYear(fy);
    setValue("financialYear", fy);
    fetchBudget(state.siteId, fy);
  };

  const getReimbursementFormDetails = () => {
    callApi(
      apiUrl?.get_reimbursement_details +
      `?reimbursementFormId=${location?.state?.reimbursementForm?.id}`
    ).then((response) => {
      if (response?.status) {
        setReimbursementData(response?.data);
        let expenseHeadTotal = 0;
        response?.data?.reimbursementFormItems?.forEach((itm) => {
          expenseHeadTotal += parseFloat(itm.total) || 0;
        });
        reset({
          siteId: response?.data?.siteId,
          date: moment(response?.data?.date).format("YYYY-MM-DD"),
          gstType: response?.data?.gstType,
          description: response?.data?.description,
          grandTotal: formatAmount(expenseHeadTotal),
          reimbursementFormItem: response?.data?.reimbursementFormItems?.map(
            (item) => ({
              item: item?.item,
              quantity: item?.quantity,
              rate: item?.rate,
              gst: item?.gst,
              total: formatAmount(item?.total),
            })
          ),
        });

        // Set financial year and load budgets
        const years = calculateFinancialYears(response?.data?.date, response?.data?.site?.endDate);
        setFinancialYears(years);
        setActiveFinancialYear(response?.data?.financialYear);
        setValue("financialYear", response?.data?.financialYear);
        fetchBudget(response?.data?.siteId, response?.data?.financialYear);
      }
      if (response?.data?.documents?.length > 0) {
        setExistingDocuments(response?.data?.documents);
      }
      setState((prev) => ({
        ...prev,
        siteId: response?.data?.site?.id,
        siteName: response?.data?.site?.name,
      }));
    });
  };

  const getAssignedSites = () => {
    const option = {
      method: "GET",
    };
    const url = apiUrl?.get_user_site;
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    callApi(url, option).then((res) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (res?.status === true) {
        setState((prev) => ({
          ...prev,
          assignedSites: res?.data?.site?.map((item) => ({
            ...item,
            value: item?.site?.id,
            label: item?.site?.name,
          })),
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const GetAllSitesList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_site + `?type=site&pageSize=${100}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setState((prev) => ({
          ...prev,
          OandMSites: response?.data?.site?.filter(
            (item) => item?.type === "O&M"
          ),
          projectSites: response?.data?.site?.filter(
            (item) => item?.type === "project"
          ),
        }));
      }
    });
  };

  const onSubmit = (data) => {
    if (data?.reimbursementFormItem?.length == 0) {
      toast.error("Please Add Items!");
      return;
    }
    const postData = {
      reimbursementFormItem: data?.reimbursementFormItem?.map((item) => ({
        ...item,
        total: parseAmount(item?.total),
      })),
      siteId: data?.siteId,
      amount: parseAmount(data?.grandTotal),
      date: data?.date,
      gstType: data?.gstType,
      description: data?.description,
      expenseHeadId: data?.expenseHeadId,
      financialYear: activeFinancialYear,
    };

    const formData = new FormData();

    for (const key in postData) {
      if (postData[key] !== undefined && postData[key] !== null) {
        if (key === "reimbursementFormItem") {
          formData.append(key, JSON.stringify(postData[key]));
        } else {
          formData.append(key, postData[key]);
        }
      }
    }

    files.forEach((f) => formData.append(f.file.name, f.file));

    const optionPurchase = {
      method: "POST",
      form_data: formData,
    };
    const endPoint = location?.state
      ? apiUrl?.update_reimbursement_form +
      `?reimbursementFormId=${location?.state?.reimbursementForm?.id}`
      : apiUrl.create_reimbursement_form;
    setIsLoading(true);
    callApi(endPoint, optionPurchase).then((res) => {
      if (res.status === true) {
        toast.success(res?.message);
        setIsLoading(false);
        navigate(-1);
      } else {
        toast.error(res?.message);
        setIsLoading(false);
      }
    });
  };

  const addItem = () => {
    const newItem = {
      item: "",
      quantity: "",
      rate: "",
      gst: "",
      total: formatAmount(0),
    };

    const currentItems = getValues(`reimbursementFormItem`) || [];
    setValue(`reimbursementFormItem`, [...currentItems, newItem]);
  };

  const handleDeleteItem = (itemIndex) => {
    const items = getValues(`reimbursementFormItem`) || [];

    const deletedItemAmount = parseAmount(items[itemIndex]?.total || "0");

    const updatedItems = items.filter((_, idx) => idx !== itemIndex);

    setValue(`reimbursementFormItem`, updatedItems);

    const currentTotal = parseAmount(getValues(`grandTotal`) || "0");
    const newTotal = currentTotal - deletedItemAmount || 0;

    setValue(`grandTotal`, formatAmount(newTotal));
  };

  const handleQuantityOrRateChange = (itemIndex, fieldType, value) => {
    const updatedValue = value;

    setValue(`reimbursementFormItem.${itemIndex}.${fieldType}`, updatedValue);

    const currentItems = watch("reimbursementFormItem") || [];
    const item = currentItems[itemIndex] || {};

    const quantity =
      fieldType === "quantity" ? +updatedValue || 0 : +item.quantity || 0;
    const rate = fieldType === "rate" ? +updatedValue || 0 : +item.rate || 0;
    const gstSlab = +item.gst || 0;

    const baseAmount = (quantity * rate).toFixed(2);
    const gstAmount = ((baseAmount * gstSlab) / 100).toFixed(2);
    const totalAmount = (
      parseFloat(baseAmount) + parseFloat(gstAmount)
    ).toFixed(2);

    setValue(
      `reimbursementFormItem.${itemIndex}.total`,
      formatAmount(totalAmount || 0)
    );

    let expenseHeadTotal = 0;
    currentItems?.forEach((itm) => {
      expenseHeadTotal += parseFloat(parseAmount(itm.total)) || 0;
    });

    setValue(`grandTotal`, formatAmount(expenseHeadTotal.toFixed(2)));
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 6 * 1024 * 1024) {
        toast.error("File size must be less than 6MB");
        event.target.value = "";
        return;
      }
      setFiles((prevFiles) => [
        ...prevFiles,
        { key: selectedFile.name, file: selectedFile }, // Use file name as key
      ]);
    }
    event.target.value = ""; // Allow reselecting the same file
  };

  const removeFile = (fileName) => {
    setFiles((prevFiles) =>
      prevFiles.filter((fileObj) => fileObj.key !== fileName)
    );
  };

  const handleDeleteDocument = () => {
    const API = `${apiUrl.delete_document}?documentId=${selectedId}`;
    callApi(API, { method: "GET" }).then((response) => {
      toggleConfirmModal();
      if (response?.status === true) {
        setExistingDocuments((prev) =>
          prev.filter((doc) => doc.id !== selectedId)
        );
        // toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };

  const ActionHandler = (id) => {
    setSelectedId(id);
    toggleConfirmModal();
  };

  const handleSearchSite = async (data = null) => {
    setState((pre) => ({ ...pre, isLoadingSite: true }));
    let API = `${apiUrl.get_user_site}${data ? `?search=${data}` : ""}`;
    const response = await callApi(API);
    if (response?.status) {
      setState((pre) => ({
        ...pre,
        assignedSites: response?.data?.site?.map((item) => ({
          ...item,
          label: item?.site?.name,
          value: item?.site?.id,
        })),
        isLoadingSite: false,
        ...(pre.siteId ? { siteId: "" } : {}),
      }));
      setValue("siteName", "");
    }
    return response;
  };

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state ? "Update" : "Create"} Reimbursement Form
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <Controller
                      name="siteId"
                      control={control}
                      rules={{ ...errorTypes.required("site") }}
                      render={({ field, fieldState }) => (
                        <SearchSelectInput
                          label="Site"
                          placeholder="Search Site"
                          value={state?.siteName}
                          onSelect={(option) => {
                            field.onChange(option?.value);
                            setState((pre) => ({
                              ...pre,
                              siteId: option?.value,
                              siteName: option?.label,
                              workorderId: null,
                              workOrderItems: [],
                              workOrder: [],
                            }));

                            const selectedSite = state?.assignedSites?.find(s => s.site?.id === option?.value);
                            const years = calculateFinancialYears(new Date(), selectedSite?.site?.endDate);
                            setFinancialYears(years);
                            const defaultFY = years[0] || getCurrentFinancialYear();
                            setActiveFinancialYear(defaultFY);
                            setValue("financialYear", defaultFY);
                            fetchBudget(option?.value, defaultFY);
                          }}
                          onBlur={field.onBlur}
                          errors={fieldState.error?.message}
                          options={state?.assignedSites}
                          onSearch={handleSearchSite}
                          isLoading={state?.isLoadingSite}
                          showAddButton={false}
                          required={true}
                          disabled={
                            state?.assignedSites?.length === 0 ||
                            location?.state?.data
                          }
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Date<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="date"
                      control={control}
                      rules={{
                        required: "This field is required",
                        validate: (value) => {
                          const checkDate = moment(value).startOf('day');
                          const today = moment().startOf('day');
                          if (checkDate.isAfter(today)) {
                            return "Future dates are not allowed";
                          }
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="date"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.date?.message} />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      GST Type<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("gstType", {
                        ...errorTypes.required("GST type"),
                      })}
                    // disabled={location?.state?.data}
                    >
                      <option value="" className="d-none">
                        Select GST Type
                      </option>
                      <option value={"IGST"}>IGST</option>
                      <option value={"CGST + SGST"}>CGST + SGST</option>
                    </select>
                    <ErrorMessage message={errors?.gstType?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="financialYear" className="form-label">
                      Financial Year<span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-control ${errors?.financialYear?.message ? "is-invalid" : ""}`}
                      {...register("financialYear", { required: "Financial Year is required" })}
                      value={activeFinancialYear}
                      onChange={handleFinancialYearChange}
                      disabled={location?.state}
                    >
                      <option value="" className="d-none">
                        Select Financial Year
                      </option>
                      {financialYears?.map((fy) => (
                        <option value={fy} key={fy}>
                          {fy}
                        </option>
                      ))}
                    </select>
                    <ErrorMessage message={errors?.financialYear?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="expenseHead" className="form-label">
                      Expense Head<span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-control ${errors?.expenseHeadId?.message ? "is-invalid" : ""}`}
                      {...register("expenseHeadId", { required: "Expense Head is required" })}
                      value={selectedExpenseHeadId}
                      onChange={(e) => {
                        const val = e.target.value;
                        setSelectedExpenseHeadId(val);
                        setValue("expenseHeadId", val);
                        const selectedBudget = expenseList.find(b => b.expensehead?.id === val);
                        setExpenseHeadItems(selectedBudget?.sitebudgetitems || []);

                        setValue("reimbursementFormItem", [
                          { item: "", quantity: "", rate: "", gst: "", total: "" }
                        ]);
                      }}
                      disabled={location?.state}
                    >
                      <option value="">Select Expense Head</option>
                      {expenseList?.map((item) => (
                        <option value={item?.expensehead?.id} key={item?.expensehead?.id}>
                          {item?.expensehead?.name}
                        </option>
                      ))}
                    </select>
                    <ErrorMessage message={errors?.expenseHeadId?.message} />
                  </div>
                </div>


                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="fs-3 rajdhani-semibold my-4">Item Details</h4>
                  <button
                    className="btn btn-outline-primary mx-2"
                    type="button"
                    onClick={() => addItem()}
                  >
                    <PlusIcon /> Add Items
                  </button>
                </div>

                {/* Item Table */}
                <table className="table mt-3">
                  <thead>
                    <tr>
                      <th>
                        Item<span className="text-danger">*</span>
                      </th>
                      <th>
                        Quantity<span className="text-danger">*</span>
                      </th>
                      <th>
                        Rate<span className="text-danger">*</span>
                      </th>
                      <th>
                        GST<span className="text-danger">*</span>
                      </th>
                      <th>
                        Total Amount<span className="text-danger">*</span>
                      </th>
                      <th>
                        Action<span className="text-danger">*</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {watch(`reimbursementFormItem`, []).map((items, i) => {
                      return (
                        <tr key={i}>
                          <td style={{ width: "25rem" }}>
                            <select
                              className={`form-select form-control ${errors?.reimbursementFormItem?.[i]?.item?.message ? "is-invalid" : ""}`}
                              {...register(`reimbursementFormItem.${i}.item`, {
                                ...errorTypes.required("Item name"),
                              })}
                              onChange={(e) => {
                                const selectedItem = expenseHeadItems.find(item => item?.item?.name === e.target.value);
                                if (selectedItem) {
                                  setValue(`reimbursementFormItem.${i}.rate`, selectedItem.unitRate);
                                  handleQuantityOrRateChange(i, "rate", selectedItem.unitRate);
                                }
                              }}
                            >
                              <option value="">Select Item</option>
                              {expenseHeadItems.map((item) => (
                                <option key={item.id} value={item?.item?.name}>
                                  {item?.item?.name}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td style={{ width: "25rem" }}>
                            <input
                              type="text"
                              className={`form-control ${errors?.reimbursementFormItem?.[i]?.quantity
                                ?.message
                                ? "is-invalid"
                                : ""
                                }`}
                              {...register(
                                `reimbursementFormItem.${i}.quantity`,
                                {
                                  ...errorTypes.required("Enter Quantity"),
                                }
                              )}
                              min={0}
                              placeholder="Quantity"
                              onChange={(e) => {
                                let value = e.target.value
                                  .replace(/[^0-9.]/g, "") // Allow only digits and dots
                                  .replace(/(\..*)\./g, "$1"); // Prevent multiple dots

                                if (!/^\d*\.?\d*$/.test(value)) {
                                  value = "";
                                }
                                e.target.value = value;
                                handleQuantityOrRateChange(
                                  i,
                                  "quantity",
                                  value
                                );
                              }}
                            />
                          </td>
                          <td style={{ width: "25rem" }}>
                            <input
                              type="text"
                              className={`form-control ${errors?.reimbursementFormItem?.[i]?.rate
                                ?.message
                                ? "is-invalid"
                                : ""
                                }`}
                              {...register(`reimbursementFormItem.${i}.rate`, {
                                ...errorTypes.required("Rate"),
                              })}
                              placeholder="Enter Rate..."
                              onChange={(e) => {
                                let value = e.target.value
                                  .replace(/[^0-9.]/g, "")
                                  .replace(/(\..*)\./g, "$1");

                                if (!/^\d*\.?\d*$/.test(value)) {
                                  value = "";
                                }
                                e.target.value = value;
                                handleQuantityOrRateChange(i, "rate", value);
                              }}
                            />
                          </td>
                          <td style={{ width: "25rem" }}>
                            <select
                              className={`form-select form-control ${errors?.reimbursementFormItem?.[i]?.gst?.message
                                ? "is-invalid"
                                : ""
                                }`}
                              {...register(`reimbursementFormItem.${i}.gst`, {
                                ...errorTypes.required("GST"),
                              })}
                              onChange={(e) => {
                                e.target.value = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                                handleQuantityOrRateChange(
                                  i,
                                  "gst",
                                  e.target.value
                                );
                              }}
                            >
                              <option value="" className="d-none">
                                GST
                              </option>
                              <option value="0">0%</option>
                              <option value="5">5%</option>
                              <option value="12">12%</option>
                              <option value="18">18%</option>
                              <option value="28">28%</option>
                            </select>
                          </td>
                          <td style={{ width: "25rem" }}>
                            <input
                              type="text"
                              className="form-control"
                              readOnly
                              disabled
                              {...register(`reimbursementFormItem.${i}.total`)}
                              placeholder="Amount"
                            />
                          </td>
                          <td>
                            <button
                              className="btn btn-outline-danger mx-3"
                              type="button"
                              onClick={() => handleDeleteItem(i)}
                            >
                              <DeleteIcon />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  {watch(`reimbursementFormItem`, []).length > 0 && (
                    <tfoot>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="fw-bold">Grand Total</td>
                        <td style={{ width: "25rem" }}>
                          <input
                            type="text"
                            className="form-control"
                            {...register(`grandTotal`)}
                            readOnly
                            disabled
                          />
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>

              <div className="row">
                <div className="col-12  " />
                <div className="col-12 col-md-6 col-lg-5">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="ref">
                      Uploads
                    </label>
                    <input
                      type="file"
                      className="form-control d-none"
                      id="documentUpload"
                      accept="image/*,application/pdf"
                      onChange={handleFileChange}
                    />
                    <label
                      htmlFor="documentUpload"
                      className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
                      style={{
                        display: "inline-block",
                        cursor: "pointer",
                        padding: 5,
                        backgroundColor: "rgb(245, 245, 245)",
                        borderRadius: 8,
                        minWidth: 150,
                      }}
                    >
                      <div className="d-flex flex-column">
                        <span className="placeholder-img">
                          <UploadPlusIcon />
                        </span>
                        <span className="text-muted">Choose Files </span>
                      </div>
                    </label>
                    <div className="preview-section p-1 mt-3" />
                  </div>
                </div>
              </div>
              {/* File Preview Section */}
              <div className="preview-section p-1 mt-3 col-lg-5">
                {files?.length > 0 &&
                  files.map((fileObj) => (
                    <div
                      key={fileObj.key} // Using file name as key
                      className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                      style={{ backgroundColor: "#f8f9fa", cursor: "pointer" }}
                    >
                      <div
                        className="w-100"
                        onClick={() => {
                          setSelectedDocument(fileObj?.file);
                          toggleModal();
                        }}
                      >
                        <span className="fs-5">{fileObj?.file?.name}</span>
                      </div>
                      <button
                        className="text-danger mx-2 bg-light"
                        onClick={() => removeFile(fileObj.key)} // Remove using file name
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  ))}

                {existingDocuments?.length > 0 &&
                  existingDocuments.map((doc) => (
                    <div
                      key={doc.key} // Using file name as key
                      className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                      style={{ backgroundColor: "#f8f9fa", cursor: "pointer" }}
                    >
                      <div
                        className="w-100"
                        onClick={() => {
                          const docUrl = {
                            url: doc?.url,
                          };
                          setSelectedDocument(docUrl);
                          toggleModal();
                        }}
                      >
                        <span className="fs-5">{doc?.name}</span>
                      </div>
                      <button
                        type="button"
                        className="text-danger mx-2 bg-light"
                        onClick={() => ActionHandler(doc.id)}
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  ))}
              </div>

              <div className="col-12">
                <div className="form-group mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    type="text"
                    rows={3}
                    className="form-control"
                    placeholder="Enter Description..."
                    {...register("description")}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  disabled={isLoading}
                  type="submit"
                  className="btn btn-primary px-5"
                >
                  {isLoading ? <Spinner /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ConfirmModal
        modal={confirmModal}
        toggle={toggleConfirmModal}
        submitHandler={handleDeleteDocument}
        isLoading={isLoading}
      />
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
